var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useFormContext, useWatch } from 'react-hook-form';
import { RecurrenceDropdown } from '../RecurrenceDropdown/RecurrenceDropdown';
import { useAdvancedBookingThreshold } from '../../hooks/useAdvancedBookingThreshold';
import { rruleEndsBeforeStart } from '../../utils/validationUtils';
export var Recurrence = function (_a) {
    var disabled = _a.disabled, showRecurrence = _a.showRecurrence;
    var setValue = useFormContext().setValue;
    var _b = __read(useWatch({
        name: ['date', 'recurrenceRule'],
    }), 2), date = _b[0], recurrenceRule = _b[1];
    var _c = useAdvancedBookingThreshold(), abtUntilDate = _c.abtUntilDate, conflictingSpaceIds = _c.conflictingSpaceIds;
    var recurrenceEndsBeforeStart = rruleEndsBeforeStart(recurrenceRule, date);
    return (_jsx(_Fragment, { children: !showRecurrence && !recurrenceRule ? null : (_jsx(RecurrenceDropdown, { onChange: function (rrule) {
                setValue('recurrenceRule', rrule, { shouldDirty: true });
            }, savedRRule: recurrenceRule, dateStart: date, disabled: disabled, abtUntilDate: abtUntilDate, hasAbtConflict: conflictingSpaceIds.length > 0, recurrenceEndsBeforeStart: recurrenceEndsBeforeStart })) }));
};
